"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatasetProducts = void 0;
const routes_1 = require("../../routes");
const getDatasetProducts = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_DATASET_PRODUITS.path, {
        params,
    });
    return response.data;
};
exports.getDatasetProducts = getDatasetProducts;
